import * as types from '../constants/actionTypes';

const initialState = {
  globalMessage: "",
  openGlobalMessage: false,
  isFetching: false,
  logs: [],
  pageName: ""
}

const environment = (state = initialState, action) => {
   switch (action.type) {

    case types.SHOW_GLOBAL_MESSAGE:
      return Object.assign({}, state, {
        globalMessage: action.message,
        openGlobalMessage: true,
        isFetching: false
      })

    case types.CLOSE_GLOBAL_MESSAGE:
      return Object.assign({}, state, {
        globalMessage: "",
        openGlobalMessage: false
      })

    case types.SHOW_SPINNER:
      return Object.assign({}, state, {
        isFetching: true
      })

    case types.HIDE_SPINNER:
      return Object.assign({}, state, {
        isFetching: false
      })

    case types.ADD_LOG_EVENT:
      return {
        ...state,
        logs: [
          action.log,
          ...state.logs
        ]
      };

    case types.CHANGE_PAGE_NAME:
      return {
        ...state,
        pageName: action.name
      };

    default:
      return state;
  }
  
}

export default environment



// WEBPACK FOOTER //
// ./src/reducers/environment.js